export default __webpack_public_path__ + "static/media/ecommerce-product-img-1.e52d67b8.png";